// operators/with-spinner.operator.ts
import { Observable, finalize, tap } from 'rxjs';

export interface SpinnerService {
  show(spinnerClass: string): void;
  hide(spinnerClass: string): void;
}

export function withSpinner<T>(spinnerService: SpinnerService, spinnerClass: string) {
  return (source$: Observable<T>): Observable<T> => {
    spinnerService.show(spinnerClass);
    
    return source$.pipe(
      finalize(() => spinnerService.hide(spinnerClass))
    );
  };
}